import { Card, Descriptions, Tag } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { ConfigurationService } from "../../services/ConfigurationService";
import { catchError } from "../../services/DaoService";
import { InlineEditableInput } from "../utils/InlineEditableInput";

const ConfigurationDetails = () => {
  const [configuration, setConfiguration] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    ConfigurationService.getInstance()
      .get()
      .then((response) => {
        setConfiguration(response.data);
      })
      .catch(catchError)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleFieldChange = (value, fieldName, record) => {
    ConfigurationService.getInstance()
      .update(record.uid, { ...record, [fieldName]: value })
      .then((response) => {
        setConfiguration(response.data);
      }).catch(catchError);
  };


  return (
    <Card loading={loading}>
      <Descriptions bor column={{ sm: 1, lg: 2, xl: 2, xxl: 2 }}>
        <Descriptions.Item label="Nom entreprise">
          <InlineEditableInput canEdit={true} fieldName="nom_entreprise" record={configuration} value={configuration?.nom_entreprise} onChange={handleFieldChange}>
            {configuration?.nom_entreprise ?? 'N/A'}
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Sigle">
          <InlineEditableInput canEdit={true} fieldName="sigle" record={configuration} value={configuration?.sigle} onChange={handleFieldChange}>
            {configuration?.sigle ?? 'N/A'}
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Adresse">
          <InlineEditableInput type="textarea" canEdit={true} fieldName="adresse" record={configuration} value={configuration?.adresse} onChange={handleFieldChange}>
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {configuration?.adresse ?? 'N/A'}
            </div>
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Téléphone">
          <InlineEditableInput type="tel" canEdit={true} fieldName="telephone" record={configuration} value={configuration?.telephone} onChange={handleFieldChange}>
            {configuration?.telephone ?? 'N/A'}
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Email">
          <InlineEditableInput type="email" canEdit={true} fieldName="email" record={configuration} value={configuration?.email} onChange={handleFieldChange}>
            {configuration?.email ?? 'N/A'}
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Permettre la synchronisation automatique des données du personnel à partir d'un système externe">
          <InlineEditableInput type="switch" canEdit={true} fieldName="allow_personnel_data_sync" record={configuration} value={configuration?.allow_personnel_data_sync} onChange={handleFieldChange}>
            {configuration?.allow_personnel_data_sync ? (
              <Tag color="success">Oui</Tag>
            ) : (
              <Tag color="error">Non</Tag>
            )}
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Permettre la synchronisation des données des départements à partir d'un système externe">
          <InlineEditableInput type="switch" canEdit={true} fieldName="allow_departement_data_sync" record={configuration} value={configuration?.allow_departement_data_sync} onChange={handleFieldChange}>
            {configuration?.allow_departement_data_sync ? (
              <Tag color="success">Oui</Tag>
            ) : (
              <Tag color="error">Non</Tag>
            )}
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Notifier le supérieur hiérarchique lorsqu'une nouvelle tâche est affectée à un personnel">
          <InlineEditableInput type="switch" canEdit={true} fieldName="notify_supervisor_on_new_task" record={configuration} value={configuration?.notify_supervisor_on_new_task} onChange={handleFieldChange}>
            {configuration?.notify_supervisor_on_new_task ? (
              <Tag color="success">Activé</Tag>
            ) : (
              <Tag color="error">Désactivé</Tag>
            )}
          </InlineEditableInput>
        </Descriptions.Item>
        <Descriptions.Item label="Mode maintenance activé">
          <InlineEditableInput type="switch" canEdit={true} fieldName="maintenance_mode" record={configuration} value={configuration?.maintenance_mode} onChange={handleFieldChange}>
            {configuration?.maintenance_mode ? (
              <Tag color="success">Oui</Tag>
            ) : (
              <Tag color="error">Non</Tag>
            )}
          </InlineEditableInput>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default ConfigurationDetails;

ConfigurationDetails.propTypes = {
  configuration: PropTypes.object,
};
